export default "__VITE_ASSET__c6ceaa16__"